/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {suggestedRecipients} from '../api'

 export const useQuerySuggestedRecipients = createReactQueryHook('suggestedRecipients', suggestedRecipients)
